<div class="d-flex flex-row align-items-center gap-3"
     [class.justify-content-center]="align === 'center'">
  @if (withIcon) {
    <span class="z-pill-icon"><i class="bi bi-bar-chart-fill" aria-hidden="true"></i></span>
  }
  <div class="z-pill" [ngClass]="pillClass">
    <h5>{{ title }}</h5>
  </div>
</div>
